export function getPackingListFieldPath(index: number, field: string) {
  return `packing_list.${index}.${field}` as const;
}

export function getCommodityFieldPath(packingListIndex: number, commodityIndex: number, field: string) {
  return `packing_list.${packingListIndex}.good_customs_information.${commodityIndex}.${field}` as const;
}
